import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Added for navigation
import '../../assets/styles/CargoExpress.css';

function CargoExpress() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Cargo Express</title>
        <meta name="description" content="Rapid and reliable express shipping for time-sensitive cargo." />
      </Helmet>
      <section className="cargo-express-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src="/assets/images/slider-loading-image1.jpg"
                className="cargo-express-image img-fluid rounded"
                alt="Cargo Express Services"
              />
            </div>
            <div className="col-md-6">
              <h2 className="service-title fw-bold mb-4">Cargo Express Services</h2>
              <p className="service-description">
                Our cargo express services ensure swift and secure delivery for your urgent shipments. Leveraging a robust network of logistics partners, we provide expedited shipping solutions tailored to your needs. From critical documents to high-value goods, RFF Cargo guarantees timely and reliable express delivery.
              </p>
              <Link to="/contact" className="btn btn-contact-us mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CargoExpress;